import React from 'react';
import { number, string } from 'prop-types';
import { VictoryLabel, TextSize } from 'victory';

export const CityLabel = ({ hoveredIdx, index, maxWidth, text, ...props }) => {
  let clippedText = text;
  let clipCount = 0;

  let width = TextSize.approximateTextSize(text, props.style).width;

  while (width > maxWidth && clipCount < text.length) {
    clipCount += 1;
    clippedText = text.slice(0, -clipCount) + '…';
    width = TextSize.approximateTextSize(clippedText, props.style).width;
  }

  return (
    console.log(this.width),
    (
      <VictoryLabel
        {...props}
        text={clippedText}
        style={{ ...props.style, fontWeight: index === hoveredIdx ? 700 : 300 }}
      />
    )
  );
};

CityLabel.propTypes = {
  hoveredIdx: number,
  maxWidth: number.isRequired,
  text: string,
  index: number,
};

export default CityLabel;



// WEBPACK FOOTER //
// ./src/components/DeltaBarChart/CityLabel.jsx